const quotaName = {
  project: [false, 'upload'],
  plant_count: [false, 'plant count'],
  credit: [true, 'credit'],
}

export const quotaToString = (
  q,
  amount,
  currencySymbol,
  showCredits = false,
  creditDecimals = 2
) => {
  const [isCurrency, name] = quotaName[q]
  return `${isCurrency ? currencySymbol : ''}${
    q === 'credit' ? amount.toFixed(creditDecimals) : amount
  } ${
    showCredits || q !== 'credit' ? name + (amount !== 1 ? 's' : '') : ''
  }`.trim()
}

export const quotasToString = (quotas, currencySymbol) => {
  const quotaStrings = Object.keys(quotas)
    .filter(q => quotas[q] > 0)
    .map(q => quotaToString(q, quotas[q], currencySymbol))

  if (quotaStrings.length > 1) {
    return (
      quotaStrings.slice(0, -1).join(', ') +
      ' and ' +
      quotaStrings[quotaStrings.length - 1]
    )
  } else {
    return quotaStrings[0]
  }
}

export const costToString = (cost, currencySymbol, deduction) => {
  const costKey = Object.keys(cost).find(k => cost[k].amount > 0)
  return costKey
    ? quotaToString(
        costKey,
        Math.max(0, cost[costKey].amount - (deduction || 0)),
        currencySymbol
      )
    : '-'
}

export function isFreeCost(cost) {
  return (
    cost &&
    Object.keys(cost.totals).every(
      k =>
        cost.totals[k].amount -
          ((cost.detection_deduction || 0) + (cost.upload_deduction || 0)) <=
        0
    )
  )
}
